import {getWrappedComponent} from '../../../appConfig';
import {galleryGlobalsStrategy} from '../../../gallery/galleryGlobalStrategy';
import {CategoryPageApp} from '../../../category/components/CategoryPageApp/CategoryPageApp';
import stylesParams from '../stylesParams';

export default getWrappedComponent({
  Component: CategoryPageApp,
  stylesParams,
  globalPropsStrategy: galleryGlobalsStrategy,
  sliderGallery: false,
});
